import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const TickIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M4.25 13.5L8.75 18L19.75 6" stroke="currentColor" />
    </SvgIcon>
  )
}
